module.exports = __webpack_public_path__ + "img/Green-Innovator-2024.d8dbf27d.png";